module.exports = new __parcel__URL__("apply_k_faq_expanded_ko.744f07f2.webp").toString();